<app-button [type]="'secondary'" label="{{ 'FILTERS' | translate }}" [showIcon]="true" [iconClass]="filterIcon" (click)="onToggleFilter($event)"></app-button>

<p-popover #filter (onShow)="filterIcon = 'pi pi-chevron-down'" (onHide)="filterIcon = 'filter-icon'">
    <div class="filter-container">
        <div class="filter-popup-fields">
            @for (f of normalizedFilterFields; track f.value) {
                @if (f.type === 'toggle' && !f.hide) {
                    <div class="prime-flex">
                        <div class="label-sm">{{ f.label | translate }}</div>
                        <div>
                            <p-toggleswitch [inputId]="'checkbox'" [name]="'checkbox'" [(ngModel)]="selected[f.value]" (ngModelChange)="emitFieldChange(f.value, $event)" size="small" />
                            <span class="toggle-label">
                                @if (f.customToggleLabel) {
                                    {{ f.customToggleLabel | translate }}
                                }
                                @else {
                                    @if(selected[f.value]) {
                                        @if(f.customOnToggleLabel){
                                            {{f.customOnToggleLabel | translate}}
                                        }@else{
                                            {{ 'YES' | translate }}
                                        }
                                    } @else {
                                        @if(f.customOffToggleLabel){
                                            {{f.customOffToggleLabel | translate}}
                                        }@else{
                                            {{ 'NO' | translate }}
                                        }
                                    }
                                }
                            </span>
                        </div>
                    </div>
                    @if (shouldShowDependent(f) && f.dependent?.type === 'dropdown') {
                        <div class="prime-flex">
                            <div class="label-sm" id="{{ f.dependent!.value }}">{{ f.dependent!.label | translate }}</div>
                            <p-select ariaLabelledBy="{{ f.value }}" placeholder="{{ 'PLEASE_SELECT' | translate }}" [(ngModel)]="selected[f.dependent!.value]"
                                (ngModelChange)="emitFieldChange(f.dependent!.value, $event)" [options]="options[f.dependent!.value]" optionValue="label" optionLabel="label">
                                <ng-template let-item pTemplate="item">
                                    {{ item.description | translate }}
                                </ng-template>
                                <ng-template let-item pTemplate="selectedItem">
                                    {{ item?.description | translate }}
                                </ng-template>
                            </p-select>
                        </div>
                    }
                    @if (shouldShowDependent(f) && f.dependent?.type === 'selection') {
                        <div class="prime-flex">
                            <div class="label-sm" id="{{ f.dependent!.value }}">{{ f.dependent!.label | translate }}</div>
                            <p-iconfield class="icon-input">
                                <div pInputText class="mock-input">
                                    {{ selected[f.dependent!.value] ? (selected[f.dependent!.value] | translate) : ("PLEASE_SELECT" | translate) }}
                                </div>
                                <p-inputicon
                                    class="icon module-icon"
                                    (click)="openSelectionPopup(f.dependent!); $event.stopPropagation()"
                                ></p-inputicon>
                            </p-iconfield>
                        </div>
                    }
                }
                @else if (f.type === 'selection' && !f.hide) {
                    <div class="prime-flex">
                        <div class="label-sm" id="{{ f.value }}">{{ f.label | translate }}</div>
                        <p-iconfield class="icon-input">
                            <div pInputText class="mock-input">
                                {{ selected[f.value] ? (selected[f.value] | translate) : ("PLEASE_SELECT" | translate) }}
                            </div>
                            <p-inputicon 
                                class="icon module-icon" 
                                (click)="openSelectionPopup(f); $event.stopPropagation()"
                            ></p-inputicon>
                        </p-iconfield>
                    </div>
                }
                @else if (f.type === 'date' && !f.hide) {
                    <div class="prime-flex">
                        <span>{{ f.label | translate }}</span>
                        <p-datepicker
                            autofocus="false"
                            dateFormat="dd-mm-yy"
                            placeholder="{{ 'PLEASE_SELECT' | translate }}"
                            [(ngModel)]="selected[f.value]"
                            (ngModelChange)="emitFieldChange(f.value, $event)"
                            inputId="{{ f.label }}"
                            name="{{ f.label }}"
                            [iconDisplay]="'input'"
                            [showIcon]="true" [showOtherMonths]="false">
                        </p-datepicker>
                    </div>
                }
                @else if (f.type === 'dropdown' && !f.hide) {
                    <div class="prime-flex">
                        <div class="label-sm" id="{{ f.value }}">{{ f.label | translate }}</div>
                        <p-select ariaLabelledBy="{{ f.value }}" placeholder="{{ 'PLEASE_SELECT' | translate }}" [(ngModel)]="selected[f.value]"
                            (ngModelChange)="emitFieldChange(f.value, $event)" [options]="options[f.value]" optionValue="label" optionLabel="label">
                            <ng-template let-item pTemplate="item">
                                {{ item.description | translate }}
                            </ng-template>
                            <ng-template let-item pTemplate="selectedItem">
                                {{ item.description | translate }}
                            </ng-template>
                        </p-select>
                    </div>
                }
            }
        </div>
        @if(dateTargetField() && dateField()){
            <div class="filter-popup-fields">
                <div class="prime-flex">
                    <span>{{ 'FILTERED_BY' | translate }}</span>
                    <div class="flex flex-wrap gap-4">
                        <div class="flex items-center">
                            <p-radiobutton name="dateTarget" inputId="createdAt" size="small" [value]="'createdAt'" [(ngModel)]="dateTarget" />
                            <label for="createdAt" class="ml-2">{{ 'CREATED' | translate }}</label>
                        </div>
                        <div class="flex items-center">
                            <p-radiobutton name="dateTarget" inputId="updatedAt" size="small" [value]="'updatedAt'" [(ngModel)]="dateTarget" />
                            <label for="updatedAt" class="ml-2">{{ 'MODIFIED' | translate }}</label>
                        </div>
                    </div>
                </div>
            </div>
        }
        @if(dateField()){
            <div class="filter-popup-fields">
                <div class="prime-flex">
                    <span>{{ 'START_DATE' | translate }}</span>
                    <p-datepicker autofocus="false" dateFormat="dd-mm-yy" placeholder="Please Select" [inputId]="'startDate'" [name]="'startDate'" [(ngModel)]="ensureRange('date').from" 
                    [maxDate]="ensureRange('date').to" (ngModelChange)="validateRange()" [iconDisplay]="'input'" [showIcon]="true">
                    </p-datepicker>
                </div>
                <div class="prime-flex">
                    <span>{{ 'END_DATE' | translate }}</span>
                    <p-datepicker autofocus="false" dateFormat="dd-mm-yy" placeholder="Please Select" [inputId]="'endDate'" [name]="'endDate'" [(ngModel)]="ensureRange('date').to" 
                    [minDate]="ensureRange('date').from" (ngModelChange)="validateRange()" [iconDisplay]="'input'" [showIcon]="true" [showOtherMonths]="false">
                    </p-datepicker>
                </div>
                @if(timeField()){
                    <div class="prime-flex">
                        <span>{{ 'START_TIME' | translate }}</span>
                        <p-datepicker autofocus="false" timeOnly="true" placeholder="Please Select" [inputId]="'startTime'" [name]="'startTime'" [(ngModel)]="ensureRange('time').from" 
                        (ngModelChange)="validateRange()" [disabled]="!ensureRange('date').from" [hourFormat]="'12'" [iconDisplay]="'input'" [showIcon]="true">
                            <ng-template #inputicon let-clickCallBack="clickCallBack">
                                <i class="pi pi-clock" (click)="clickCallBack($event)"></i>
                            </ng-template>
                        </p-datepicker>
                    </div>
                    <div class="prime-flex">
                        <span>{{ 'END_TIME' | translate }}</span>
                        <p-datepicker autofocus="false" timeOnly="true" placeholder="Please Select" [inputId]="'endTime'" [name]="'endTime'" [(ngModel)]="ensureRange('time').to" 
                        (ngModelChange)="validateRange()" [disabled]="!ensureRange('date').to" [hourFormat]="'12'" [iconDisplay]="'input'" [showIcon]="true">
                            <ng-template #inputicon let-clickCallBack="clickCallBack">
                                <i class="pi pi-clock" (click)="clickCallBack($event)"></i>
                            </ng-template>
                        </p-datepicker>
                    </div>
                }
            </div>
        }
        <div class="filter-actions">
            <app-button [type]="'secondary'" [label]="'RESET' | translate" [extraClasses]="'btn-blue-text'" (click)="onReset()"/>

            <app-button [type]="'primary'" [label]="'FILTER_RESULTS' | translate" (click)="onApply()"/>
        </div>
    </div>
</p-popover>